import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Row, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux'
import { calendarOperations } from './state';
import ModuleContainer from '../../components/ModuleContainer';
import TableTemplate from '../../components/TableTemplate';
import { FaPlus, FaEye, FaTrashAlt, FaEdit } from 'react-icons/fa';
import {
    MODE_EDIT, MODE_VIEW, SUCCESS, NOTIF_SUCCESS, NOTIF_ERROR, DATE_FORMAT, PAGINATION_NUMBER, DAYS, ENDDATE_TEMPLATE, STARTDATE_TEMPLATE,
    CALENDAR, SUCCESS_BUTTON, ADD_EVENT, LINK, BLACK, BLUE, RED, YES, NO, SECONDARY, DANGER
} from '../../../utils/constants';
import { DELETE_CALENDAR, DELETE_MESSAGE, MSG_DEFAULT_ERROR  } from '../../../utils/messages';
import { ADD_CALENDAR_ROUTE, VIEW_CALENDAR_ROUTE } from './routes';
import ViewHeader from '../../components/ViewHeader';
import ConfirmationModal from '../../components/ConfirmationModal';
import { isNullOrUndefined } from '../../../../node_modules/util';
import { SideNotification } from '../../../utils/common';
import Pagination from '../../components/PaginationTemplate';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import debounce from 'lodash.debounce';


class Polls extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showDeleteModal: false,
            modalId: 0,
            search: '',
            pageNumber: 1,
            activePage: 1,
            totalPages: 0,
            calendarList: [],
            startDate: null,
            endDate: null,
            clicked: false,
            first: true,
            prevEndDate: null,
            prevStartDate: null
        }

        this.retrieveList = debounce(this.retrieveList.bind(this), 500);
        this.deleteRow = debounce(this.deleteRow.bind(this), 500);
    }

    componentDidMount() {
        this.retrieveList();
    }

    retrieveList = () => {
        let data = {
            "pageNumber": this.state.activePage,
            "searchPollField": this.state.search,
            "startDate": this.state.prevStartDate,
            "endDate": this.state.prevEndDate,
        }
        this.props.getCalendarList(data)
            .then(result => {
                if (SUCCESS === result.status) {
                    this.setState({ calendarList: result.data.list, totalPages: result.data.totalPage });
                }
            }).catch(() => { 
                SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR);
            })



    }

    handlePageClick = (pageNumber) => {
        this.setState({ activePage: pageNumber, calendarList: [] }, () => this.retrieveList());
    }

    handlePagePrev = () => {
        this.setState({ activePage: this.state.activePage - PAGINATION_NUMBER, calendarList: [] }, () => this.retrieveList());
    }

    handlePageNext = () => {
        this.setState({ activePage: this.state.activePage + PAGINATION_NUMBER, calendarList: [] }, () => this.retrieveList());
    }

    handlePageFirst = () => {
        this.setState({ activePage: PAGINATION_NUMBER, calendarList: [] }, () => this.retrieveList());
    }

    handlePageLast = () => {
        this.setState({ activePage: this.state.totalPages, calendarList: [] }, () => this.retrieveList());
    }
    handleSearchChange = (event) => {
        this.setState({
            search: event.target.value,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            activePage: 1
        }, () => this.retrieveList());
    }

    viewCalendar = (data, type) => {

        let params = {};
        if (MODE_EDIT === type || MODE_VIEW === type) {
            params.data = data;
            params.type = type;
            this.props.history.push({
                pathname: VIEW_CALENDAR_ROUTE + `/${data.calendarId}`,
                state: params
            })
        }
        else {
            this.props.history.push(ADD_CALENDAR_ROUTE);
        }
    }

    toggleDelete = (row) => {
        this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal, modalId: isNullOrUndefined(row) ? null : row.calendarId }))
    }

    deleteRow = () => {
        this.props.deleteCalendar(this.state.modalId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.retrieveList();
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    handleChange = (date, name) => {

        this.setState({
            [name]: date
        })


    }

    filter = () => {

        let startDate = this.state.startDate;
        let endDate = this.state.endDate;
        //when the user click the filter button and both datepicker is null
        if (isNullOrUndefined(this.state.startDate) && isNullOrUndefined(this.state.endDate)) {
            startDate = moment();
            endDate = moment();

        }
        //check if start date is null and the button is clicked
        else if (isNullOrUndefined(this.state.startDate)) {
            startDate = moment();


        }
        //check if end date is null and the button is clicked
        else if (isNullOrUndefined(this.state.endDate)) {
            endDate = moment();
        }
        this.setState({
            clicked: true,
            startDate: startDate,
            endDate: endDate,
            prevStartDate: startDate,
            prevEndDate: endDate,
            calendarList: []
        }, () => this.retrieveList())
    }



    renderFilterDate = () => {

        let startDateValue = isNullOrUndefined(this.state.startDate) ? moment().format(DATE_FORMAT) : moment(this.state.startDate).format(DATE_FORMAT)
        let endDateValue = isNullOrUndefined(this.state.endDate) ? moment().format(DATE_FORMAT) : moment(this.state.endDate).format(DATE_FORMAT)

        return (
            <Row className="date-filter">
                <b className="date-text-filter">Date From</b>

                <DatePicker
                    className="filter form-control"
                    defaultValue={this.state.startDate}
                    selected={moment(startDateValue).toDate()}
                    value={moment(startDateValue).format(DATE_FORMAT)}
                    onChangeRaw={(event) => event.preventDefault()}
                    onChange={newValue => {
                        if (moment(endDateValue).isBefore(newValue)) {
                            this.handleChange(moment(newValue).add(1, DAYS), ENDDATE_TEMPLATE)
                        }
                        this.handleChange(moment(newValue), STARTDATE_TEMPLATE)
                    }
                    }
                    peekNextMonth
                    name="startDate"
                    dropdownMode="select"
                    startDate={moment(startDateValue)}
                    endDate={moment(endDateValue)}

                />

                <b className="date-text-filter">Date To</b>

                <DatePicker
                    className="filter form-control"
                    selected={moment(endDateValue).toDate()}
                    value={moment(endDateValue).format(DATE_FORMAT)}
                    onChange={newValue => { this.handleChange(moment(newValue), ENDDATE_TEMPLATE) }}
                    minDate={moment(moment(startDateValue))}
                    peekNextMonth
                    name="endDate"
                    onChangeRaw={(event) => event.preventDefault()}
                    dropdownMode="select"

                />


                <Button onClick={() => this.filter()}>Filter</Button>
            </Row>
        )

    }


    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    withSearch={true}
                    renderFilterDate={this.renderFilterDate()}
                    title={CALENDAR}
                    onSearchChange={this.handleSearchChange}
                    rightButtons={[
                        { variant: SUCCESS_BUTTON, label: ADD_EVENT, icon: FaPlus, onClick: this.viewCalendar }
                    ]}
                />
                {
                    this.state.clicked &&
                    <p>
                        <b>Filters: </b>
                        <span>{this.state.clicked && moment(this.state.prevStartDate).format(DATE_FORMAT).concat("  to   ")}</span>
                        <span>{this.state.clicked && moment(this.state.prevEndDate).format(DATE_FORMAT)}</span>
                    </p>
                }
                <TableTemplate
                    tableHeader={this.props.calendarTableHeaders}
                    tableColumns={this.props.calendarTableColumns}
                    tableList={this.state.calendarList}
                    rowButtons={[
                        { variant: LINK, icon: FaEye, color: BLACK, onClick: this.viewCalendar, type: MODE_VIEW },
                        { variant: LINK, icon: FaEdit, color: BLUE, onClick: this.viewCalendar, type: MODE_EDIT },
                        { variant: LINK, icon: FaTrashAlt, color: RED, onClick: this.toggleDelete }
                    ]}
                />

                <Pagination
                    {...this.state}
                    handlePageClick={this.handlePageClick}
                    handlePagePrev={this.handlePagePrev}
                    handlePageNext={this.handlePageNext}
                    handlePageLast={this.handlePageLast}
                    handlePageFirst={this.handlePageFirst}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_CALENDAR}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteRow, variant: DANGER }
                    ]}
                />
            </ModuleContainer>
        )
    }


}

const mapStateToProps = (state) => {
    return {
        calendarList: state.calendars.calendarList,
        calendarTableHeaders: state.calendars.calendarTable.tableHeaders,
        calendarTableColumns: state.calendars.calendarTable.tableColumns,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        //operations here
        getCalendarList: calendarOperations.getCalendarList,
        deleteCalendar: calendarOperations.deleteCalendar
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Polls);
